
import React, { useState, useRef } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import { createAccount } from "../../actions/auth";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { relativeTimeRounding } from "moment/moment";


export default function CreateAccount() {

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const [password, setPassword] = useState("");
    const [password_2, setPassword_2] = useState("");




    const [loading, setLoading] = useState(false);
    const { isLoggedIn } = useSelector(state => state.auth);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onChangeEmail = (e) => {
        const email = e.target.value;
        setEmail(email);
    };

    const onChangeFirstName = (e) => {
        const password = e.target.value;
        setFirstName(password);
    };
    const onChangeLastName = (e) => {
        const password = e.target.value;
        setLastName(password);
    };

    const isNotEmpty = (str) => {
        return str && str != null && str.length > 0;
    }

    const handleSubmit = (event) => {


        if (isNotEmpty(firstName) && isNotEmpty(lastName) && isNotEmpty(email)) {

            event.preventDefault();
            setLoading(true);

            if(password != password_2){
                toast.error(`Password don't match.`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER });
                return;
            }

            dispatch(createAccount(firstName, lastName, email, password))
                .then(() => {
                    toast.success(
                        `Your account has been submited. Please wait for admin approval`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                    );
                    setLoading(false);
                    navigate("/");
                })
                .catch(() => {
                    toast.error(
                        `An error has occurred.`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                    );
                    setLoading(false);
                });
        } else {
            toast.error(
                `Please fill your firstname, lastname and email.`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
            );
        }


    };

    const handleBack = (event) => {
        event.preventDefault();
        navigate("/");

    };

    if (isLoggedIn) {
        navigate("/")
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <img
                    src={`${process.env.PUBLIC_URL}/lines.png`}
                    alt="lines"
                    height={300}
                    className="lines"
                />

                <Box  sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        value={firstName}
                        onChange={onChangeFirstName}
                        id="email"
                        label="First Name"
                        name="firstname"
                        autoComplete="firstname"
                        autoFocus
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        value={lastName}
                        onChange={onChangeLastName}
                        id="lastname"
                        label="Last Name"
                        name="lastname"
                        autoComplete="lastname"

                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        value={email}
                        onChange={onChangeEmail}
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"

                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password_2}
                        onChange={(e) => setPassword_2(e.target.value)}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3 }}
                        onClick={handleSubmit}>

                        {loading ?
                            <Box
                                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <CircularProgress />
                            </Box> : <>Submit</>
                        }
                    </Button>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 2 }}
                        onClick={handleBack}>

                        Back
                    </Button>


                </Box>
            </Box>

        </Container>
    );
}